// In-app browsers (WhatsApp, Instagram, …) render a .pkpass as raw text instead
// of handing it to Apple Wallet. Detect them so we can show an "open in Safari"
// landing page rather than auto-loading the binary.
export function isIosDevice(): boolean {
  const ua = navigator.userAgent || '';
  if (/iphone|ipad|ipod/i.test(ua)) return true;
  // iPadOS Safari identifies as a Mac but is a touch device.
  return /macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
}

export function isInAppBrowser(): boolean {
  const ua = navigator.userAgent || '';
  // WhatsApp iOS tags its in-app browser as "[WAiOS/<version>]" (Android:
  // "WABR"); it otherwise carries a full Safari UA and even passes the
  // feature checks below, so the marker is the only reliable signal.
  if (
    /WAiOS|WABR|WhatsApp|Instagram|FBAN|FBAV|FB_IAB|Line\/|Snapchat|MicroMessenger|Twitter/i.test(
      ua
    )
  ) {
    return true;
  }
  if (!isIosDevice()) return false;
  // iOS WKWebViews omit the "Safari" token that real Mobile Safari carries…
  if (!/safari/i.test(ua)) return true;
  // …but some apps (WhatsApp among them) now ship a Safari-like UA. Real Mobile
  // Safari always exposes navigator.standalone (false/true) and ApplePaySession;
  // an embedded WKWebView has neither. Either missing → in-app browser.
  const nav = navigator as Navigator & { standalone?: boolean };
  if (nav.standalone === undefined) return true;
  if (typeof (window as Window & { ApplePaySession?: unknown }).ApplePaySession === 'undefined') {
    return true;
  }
  return false;
}

/**
 * iOS 17+ opens `x-safari-https://host/path` in Safari from any app that
 * forwards unknown URL schemes to the system (WhatsApp, Instagram, …). The
 * only way out of an in-app WKWebView for things it can't render, such as a
 * .pkpass. Older iOS silently ignores the tap, so callers keep a fallback.
 */
export function safariUrl(httpsUrl: string): string {
  return httpsUrl.replace(/^https:\/\//, 'x-safari-https://');
}
